export const concurrent = async (funcs: Array<() => any>, limit: number) => {
  const returnVals = [];
  while (funcs.length) {
    // eslint-disable-next-line no-await-in-loop
    returnVals.push(await Promise.all(funcs.splice(0, limit).map((f) => f())));
  }
  return returnVals;
};
